import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Rounded phone outline + home-button dot (Figma 2843:24042) — flags the
// app-version requirement note for the live order tracker. Portrait aspect
// ratio (not square), so unlike the shared outlined-icon contract `size`
// sets the height only and the width scales to match, rather than forcing a
// square render.
const Smartphone = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    width={(size * 13.6667) / 18.6667}
    height={size}
    viewBox="0 0 13.6667 18.6667"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6.83333 14.3333H6.84167M2.66667 1H11C11.9205 1 12.6667 1.74619 12.6667 2.66667V16C12.6667 16.9205 11.9205 17.6667 11 17.6667H2.66667C1.74619 17.6667 1 16.9205 1 16V2.66667C1 1.74619 1.74619 1 2.66667 1Z" />
  </svg>
)

export default Smartphone
